import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

class PrimaryModel extends Component {
    _isMounted = false;
    state = {
        item: {},
        errors: {}
    };
    componentDidMount() {
        this._isMounted = true;  
    }  
    primary = () => {
        let temp = this.props.item;
        //temp['primary'] = '1';
        this.props.primary(this.props.item.id, temp)
            .then(res => {
                this.props.hidePrimary();
            })
            .catch(error => {
                switch (error.response.status) {
                    case 422:
                        this.setState({ errors: error.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });
    };

    componentWillUnmount() {
        this._isMounted = false;       
    }

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
			    <button onClick={this.props.hidePrimary} type="button" className="modal-close" data-dismiss="modal" aria-hidden="true"><img src="/images/close.svg" alt="close"/></button>
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-header">
                        <img src="/images/creditCardModel.png" alt=""></img>
                    </div>
                    <h2 className="model-title" id="model-title"></h2>
                    <div className="model-content">
                        <div
                            id="model-content"
                            className=" text-center model-html-container"
                        >
                            Make this card your primary payment method for all future billings?
                        </div>
                        <div
                            className="model-validation-message"
                            id="model-validation-message"
                        ></div>
                    </div>
                    <div className="model-actions">
                        <button
                            type="button"
                            onClick={this.props.hidePrimary}
                            className="btn btn-default"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.primary}
                        >
                            Confirm
                        </button>
                        
                    </div>
                </div>
            </div>
        );
    }
}
PrimaryModel.contextType = AppContext;
export default PrimaryModel;



// WEBPACK FOOTER //
// ./src/components/writer/billing/PrimaryModel.js